<template>
  <div>
    <p v-if="fetching_data" class="has-text-centered spinner"><img src="/static/img/spinner.svg" alt="Getting review detail" /></p>
    <ad v-if="!isMobileAds" v-on:ad-loaded="updateAdCounter" :ad-object="firstAd" :no-margin="hideFirstDesktopAd"></ad>
    <p v-if="isMobileAds" class="has-text-centered is-hidden-tablet">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="firstAd"></ad>
    </p>
    <div class="tabs is-hidden-tablet">
      <ul>
        <li>
          <router-link :to="`/${business}`" v-html="reviewOfHtml"></router-link>
        </li>
      </ul>
    </div>
    <p v-if="!isMobileAds" class="has-text-centered is-hidden-mobile">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="secondAd"></ad>
    </p>
    <flash-message size="is-size-7" :add-bottom-margin="flashBottomMargin"></flash-message>
    <review-card :author="reviewDetail.author"
                 :author-avatar="reviewDetail.authorAvatar"
                 :author-id="reviewDetail.author_id"
                 :author_created_date="reviewDetail.author_created_date"
                 :author_total_reviews_count="reviewDetail.author_total_reviews_count"
                 :business="reviewDetail.business_name"
                 :business-logo="reviewDetail.business_logo"
                 :business-slug="reviewDetail.business_slug"
                 :is-detailed-card="isDetailedCard"
                 :npsRating="reviewDetail.nps_rating"
                 :review-blurb="reviewDetail.review_content"
                 :review-business-reporting="reviewDetail.business_reporting"
                 :review-date="reviewDetail.created_at"
                 :review-rating="reviewDetail.review_rating"
                 :review-slug="permalink"
                 :review-title="reviewDetail.review_title"
                 :show-business="showBusiness"
                 :showNPSRating="true"
                 author-avatar-color="#88397F"
                 v-if="hasReviewDetail && !fetching_data"
    ></review-card>
    <div v-if="isMobileAds" class="is-hidden-tablet has-text-centered">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="secondAd"></ad>
    </div>
    <div v-if="!isMobileAds" class="has-text-centered is-hidden-mobile">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="fourthAd" :force-fluid="hideFirstDesktopAd"></ad>
    </div>
<!--    <div class="is-hidden-mobile"><leaderboard></leaderboard></div>-->
    <review-message :business-logo="reviewMessage.businessLogo" :created-at="reviewMessage.created_at"
                    :is-linked-to-user="reviewMessage.isLinkedToUser"
                    :key="reviewMessage.id"
                    :message-body="reviewMessage.body"
                    :message-from="reviewMessage.from"
                    :message-owner="reviewMessage.owner"
                    :message-type="reviewMessage.type"
                    :show-private-reply-badge="reviewMessage.showPrivateBadge"
                    v-for="reviewMessage in messages"
                    v-if="hasReviewMessages"
    ></review-message>
    <div class="reply-container" v-if="isLoggedIn && isReviewOwner">
      <p class="has-text-weight-bold reply-header">Write a reply:</p>
      <wysiwyg-editor :shouldClear="clearReplyBox" :value="reply" name="replyBox" v-model="reply"></wysiwyg-editor>
      <div class="field has-addons has-addons-right is-hidden-mobile">
        <div class="select">
          <p class="control">
            <select :disabled="isReplying" v-model="replyPublic">
              <option selected value="1">Public reply</option>
              <option value="2">Private reply</option>
            </select>
          </p>
        </div>
        <p class="control">
          <a :class="[{ 'is-loading': isReplying }, 'button is-button-blue is-button-medium']"
             :disabled="reply === '' || isReplying"
             @click.prevent="postReply">
            REPLY
          </a>
        </p>
      </div>
      <div class="is-hidden-tablet">
        <div class="select is-fullwidth">
          <p class="control">
            <select v-model="replyPublic">
              <option selected value="1">Public reply</option>
              <option value="2">Private reply</option>
            </select>
          </p>
        </div>
        <p class="control mar-top">
          <a :class="[{ 'is-loading': isReplying }, 'button is-button-blue is-fullwidth']"
             :disabled="reply === '' || isReplying"
             @click.prevent="postReply">
            REPLY
          </a>
        </p>
      </div>
    </div>
    <div v-if="hasReviewMessages && isMobileAds" class="is-hidden-tablet has-text-centered">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="thirdAd"></ad>
    </div>
    <h3 id="fb-comments" class="blue-heading"><i class="fa fa-comments-o"></i> Public comments</h3>
    <div class="fb-comments" :data-href="fbCommentUrl" data-width="100%"></div>
  </div>
</template>
<script>
  /* global googletag */
  /* eslint no-undef: "error" */

  import auth from '@/mixins/auth.js'
  import axios from 'axios'
  import ReviewCard from '@/components/ReviewCard'
  import ReviewMessage from '@/components/ReviewMessage'
  import Leaderboard from '@/components/Leaderboard'
  import LeaderBoardMobile from '@/components/LeaderBoardMobile'
  import FlashMessage from '@/components/FlashMessage'
  import WysiwygEditor from '@/components/Wysiwyg'
  import misc from '@/mixins/misc.js'
  import adsConfig from '@/mixins/ad_config'
  import Ad from '@/components/ProgrammaticAds'

  export default {
    name: 'BusinessReviewDetail',
    props: {
      business: {
        type: String
      },
      permalink: {
        type: String
      }
    },
    mixins: [auth, misc, adsConfig],
    components: {
      ReviewCard,
      ReviewMessage,
      Leaderboard,
      LeaderBoardMobile,
      FlashMessage,
      WysiwygEditor,
      Ad
    },
    created() {
      window.events.$on('refreshReviewDetail', () => {
        this.getReviewDetail()
      });
    },
    mounted() {
      setTimeout(() => {
        if (!window.FB) {
          window.fbAsyncInit = () => {
            FB.init({
              appId: process.env.FACEBOOK_APP_ID,
              status: true,
              xfbml: true,
              version: 'v2.10'
            })
          }
        } else {
          window.FB.init({
            appId: process.env.FACEBOOK_APP_ID,
            status: true,
            xfbml: true,
            version: 'v2.10'
          })
        }
        if (this.$route !== undefined) {
          this.getReviewDetail()
        }
      }, 100)
      this.loadAds()
      if (!this.isMobileAds) {
        const desktopAdsArray = [
          this.thirdAd,
          this.fifthAd,
          this.sixthAd
        ]
        window.events.$emit('review-detail-desktop-ads', desktopAdsArray)
      }
    },
    computed: {
      hasReviewDetail () {
        return this.reviewDetail !== null
      },
      hasReviewMessages () {
        return this.messages.length > 0
      },
      meta_title () {
        if (this.reviewDetail !== null) {
          if (this.reviewDetail.review_rating >= 4) {
            return `[Happy Customer] ${this.reviewDetail.review_title} | ${this.reviewDetail.business_name}`
          } else {
            if (this.reviewDetail.replied) {
              return `[Responded] ${this.reviewDetail.review_title} | ${this.reviewDetail.business_name}`
            }
            return `${this.reviewDetail.review_title} | ${this.reviewDetail.business_name}`
          }
        }
        return ''
      },
      meta_description () {
        if (this.reviewDetail !== null && this.reviewDetail.review_rating) {
          return `${this.reviewDetail.author} - `+ this.reviewDetail.review_content.replace(/<(?:.|\n)*?>/gm, '').substring(0, 49)+ `...`
        }
        return ''
      },
      full_url () {
        return window.location.href
      },
      fbCommentUrl () {
        if (this.reviewDetail !== null) {
          return `https://www.hellopeter.com/${this.reviewDetail.business_slug}/reviews/${this.reviewDetail.permalink}`
        }
        return ''
      },
      businessSlug () {
        if (this.reviewDetail !== null) {
          return `${this.reviewDetail.business_slug}`
        }
        return ''
      },
      businessLogo () {
        if (this.reviewDetail !== null) {
          return `${this.reviewDetail.business_logo}`
        }
        return ''
      },
      openGraphBanner () {
        if (this.reviewDetail !== null) {
          return `${this.reviewDetail.details.og_url}`
        }
        return ''
      },
      industryLogo () {
        if (this.reviewDetail !== null) {
          return `${this.reviewDetail.industry_logo}`
        }
        return ''
      },
      reviewPermalink () {
        if (this.reviewDetail !== null) {
          return `${this.reviewDetail.permalink}`
        }
        return ''
      },
      reviewOfHtml () {
        if (this.reviewDetail !== null) {
          return `A review of<span class="has-text-weight-bold">&nbsp;${this.reviewDetail.business_name}</span>`
        }
        return ''
      },
      isReviewOwner () {
        const loggedInProfile = localStorage.getItem('profile_id')
        if (typeof loggedInProfile !== 'undefined' && loggedInProfile !== null && this.reviewDetail !== null && typeof this.reviewDetail.author_id !== 'undefined') {
          return loggedInProfile === this.reviewDetail.author_id
        }

        return false
      },
      getCanonicalUrl () {
        let businessSlug = ''
        let permalink = ''
        if (this.reviewDetail !== null) {
          businessSlug = this.reviewDetail.business_slug
          permalink = this.reviewDetail.permalink
        }
        return [
          {
            rel: 'canonical',
            href: `${window.location.protocol}//${window.location.host}/${businessSlug}/reviews/${permalink}`
          }
        ]
      }
    },
    data () {
      return {
        reviewDetail: null,
        fetching_data: false,
        isReplying: false,
        showBusiness: false,
        isDetailedCard: true,
        flashBottomMargin: true,
        messages: [],
        reply: '',
        clearReplyBox: false,
        replyPublic: '1',
        adMobileSquare: true
      }
    },
    methods: {
      getReviewDetail () {
        const url = `/consumer/business/${this.business}/reviews/${this.permalink}`
        axios.get(url)
          .then(({data}) => {
            this.reviewDetail = data
            if (typeof data.messages !== 'undefined') {
              this.messages = data.messages
            }
            this.$gtm.trackEvent({
              event: 'pageLoad',
              virtualPageUrl: this.$router.currentRoute.path,
              virtualPageTitle: this.meta_title,
              brandName: '',
              industryName: ''
            })
            window.prerenderReady = true
            googletag.cmd.push(() => {
              googletag.pubads().setTargeting('Pagetype', this._routeName)
              googletag.pubads().setTargeting('URL', window.location.href)
              if (data.nps_rating !== null) {
                let happyText = 'Unhappy customer'
                if (data.nps_rating === 7 || data.nps_rating === 8) {
                  happyText = 'Undecided customer'
                } else if (data.nps_rating === 9 || data.nps_rating === 10) {
                  happyText = 'Happy customer'
                }
                googletag.pubads().setTargeting('Customer Type', happyText)
              }
              googletag.pubads().setTargeting('Stars', data.reviewRating)
              googletag.pubads().setTargeting('Brand', data.business_name)
              googletag.pubads().collapseEmptyDivs()
              googletag.enableServices()
            })
          })
          .catch((error) => {
            if (typeof error !== 'undefined' && typeof error.response !== 'undefined' && typeof error.response.status !== 'undefined') {
              if (error.response.status === 404) {
                window.location.href = '/404'
              } else {
                console.log('stringify error', JSON.stringify(error))
              }
            }
          })
      },
      parseFB () {
        if (window.FB) {
          window.FB.XFBML.parse()
        }
      },
      postReply () {
        if (this.reply.trim().length > 0) {
          this.isReplying = true
          axios.post(`/consumer/reviews/${this.permalink}/reply`, {
            reply: this.reply,
            public: this.replyPublic === '1'
          })
            .then(({data}) => {
              this.recacheReviewDetail(this.business, this.reviewDetail.permalink) //Review detail page

              this.isReplying = false
              this.reply = ''
              this.reviewDetail = data
              if (typeof data.messages !== 'undefined') {
                this.messages = data.messages
              }
              // response.data.userDisplayName = localStorage.getItem('first_name') + ' ' + localStorage.getItem('last_name')
              // this.messages.push(response.data)
              this.clearReplyBox = !this.clearReplyBox
              flash('Review message posted successfully.', 'is-success')
            })
            .catch((error) => {
              this.isReplying = false
              flash('There was an error replying to this review. Please try again later!', 'is-danger')
            })
        }
      }
    },
    watch: {
      fbCommentUrl() {
        setTimeout(() => {
          this.parseFB()
        }, 500)
      }
    },
    metaInfo () {
      return {
        title: this.meta_title,
        titleTemplate: '%s on Hellopeter.com',
        meta: [
          { name: 'description', content: this.meta_description },
          {'property': 'og:description', 'content': this.meta_description},
          {'property': 'og:image', 'content': (encodeURI(this.openGraphBanner) ? encodeURI(this.openGraphBanner) : this.industryLogo)},
          // {'property': 'og:title', 'content': this.meta_title},
          // {'property': 'og:image', 'content': (encodeURI(this.businessLogo) ? encodeURI(this.businessLogo) : this.industryLogo)},
          {'property': 'twitter:card', 'content': 'summary_large_image'},
          {'property': 'twitter:description', 'content': this.meta_description},
          {'property': 'twitter:image', 'content': (encodeURI(this.openGraphBanner) ? encodeURI(this.openGraphBanner) : this.industryLogo)},
          {'property': 'og:url', 'content': `${window.location.protocol}//${window.location.host}/${this.businessSlug}/reviews/${this.reviewPermalink}`},
          {'property': 'og:type', 'content': 'website'},
          {'property': 'fb:app_id', 'content': process.env.FACEBOOK_APP_ID}
        ],
        link: this.getCanonicalUrl,
        bodyAttrs: {
          class: 'review'
        }
      }
    }
  }
</script>
<style scoped>
  .blue-heading {
    font-weight: bold;
    color: #58595B;
    height: 43px;
    line-height: 43px;
    border-top: 1px solid #C9C9C9;
    border-bottom: 1px solid #C9C9C9;
    margin: 3rem 0 1.5rem 0;
  }

  .tabs {
    background-color: #F5F5F5;
    margin-bottom: 0;
  }

  .tabs > ul {
    border: none;
  }

  .tabs > ul > li > a {
    color: #58595B;
    font-size: 0.9rem;
    border-bottom: none;
    padding: 0.7rem 1rem;
  }

  .reply-header {
    color: #58595B;;
    font-size: 1rem;
    margin-top: 20px;
  }

  select, .select:not(.is-multiple) {
    height: 2.5rem;
    border-radius: 0;

  }

  .select select:not([multiple]) {
    padding-right: 6.5em;
  }

  .select {
    margin-right: 20px;
  }

  .button {
    border-radius: 0;
    border: none;
    height: 2.5rem;
    color: #ffffff;
    background-color: #30AAE1;
    padding-left: 2rem;
    padding-right: 2rem;
    font-size: 0.85rem;
  }

  @media screen and (max-width: 767px) {
    .blue-heading {
      margin-top: 0;
    }

    .reply-container {
      padding: 0 1rem;
    }

    .mar-top {
      margin-top: 0.5rem;
      margin-bottom: 2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/business/BusinessReviewDetail.vue